import { on } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { FeatureScopeActions } from '../feature-scope/feature-scope.actions';
import { LocationSetsActions } from './location-sets.actions';
import { LocationSetTypesActions } from '../location-set-types/location-set-types.actions';
import { MenuBaseActions } from '../base/menu-base.actions';
import { AsyncActions } from './location-sets.actions';
import {LocationSet} from '@emm/core/models/location-set.model';
import {asyncActionState, AsyncActionState} from '@emm/core/util/async-action-state';
import {Venue} from '@emm/core/models/venue.model';
import {locationSetsSort} from '@emm/core/util/sort.util';
import {withLoadables} from '@emm/core/util/ngrx.util';

export const locationSetsFeatureKey = 'locationSets';

export interface LocationSetsState extends EntityState<LocationSet>, AsyncActionState {
    filter: string;
    selectedTag: string | null;
    selectedVenue: Venue | null;
}

export const adapter: EntityAdapter<LocationSet> = createEntityAdapter<LocationSet>({
    selectId: (item: LocationSet) => item.tag,
    sortComparer: locationSetsSort,
});

export const initialState: LocationSetsState = adapter.getInitialState({
    selectedTag: null,
    filter: null,
    selectedVenue: null,
    ...asyncActionState.initial,
});

const { loadActions, successActions, errorActions } = AsyncActions;

export const locationSetsReducer = withLoadables<LocationSetsState>({
    loadActions,
    successActions,
    errorActions
})(
    initialState,

    on(MenuBaseActions.init, () => ({
        ...initialState
    })),

    on(LocationSetsActions.loadAllByScopeSuccess, LocationSetsActions.loadLocationsByParentSuccess,
        (state: LocationSetsState, { locationSets }) =>
            adapter.setAll(locationSets, state)
    ),

    on(
        FeatureScopeActions.select,
        LocationSetTypesActions.load,
        LocationSetsActions.loadAllByScope,
        (state: LocationSetsState) => ({
            ...state,
            selectedTag: null
        })
    ),

    on(LocationSetsActions.select, (state: LocationSetsState, { tag }) => ({
        ...state,
        selectedTag: tag
    })),

    on(LocationSetsActions.selectVenue, (state: LocationSetsState, { venue }) => ({
        ...state,
        selectedVenue: venue
    })),

    on(LocationSetsActions.updateFilter, (state: LocationSetsState, { filter }) => ({
        ...state,
        filter
    }))

);
